import { useEffect, useState, useMemo } from "react";
import { axiosIns } from "../../utils";
import { Container, Row } from "reactstrap";

import "nouislider/distribute/nouislider.css";
import DeleteModal from "../../Components/Common/DeleteModal";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";

//redux
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// import { red } from "@material-ui/core/colors";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

const SubscriptionTypesPage = (props) => {

  const [isLoading, setIsLoading] = useState(true);
  const [recrutements, setRecrutements] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosIns.get("/abonnement-types/");
        setRecrutements(response?.data || response || []);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const handleDeleteProduct = () => {
    if (recrutements) {
      // dispatch(deleteProducts(articles.id));
      setDeleteModal(false);
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    ele.forEach((element) => {
      del.style.display = "none";
    });
  };

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".entrepriseCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            onClick={() => checkedAll()}
          />
        ),
        Cell: (cellProps) => {
          return (
            <input
              type="checkbox"
              className="entrepriseCheckBox"
              value={cellProps.row.original.id}
            />
          );
        },
        id: "#",
      },
      {
        Header: props.t("DESIGNATION"),
        accessor: "designation",
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center ">
              <div className="flex-grow-1">
                <h5
                  className="fs-14 mb-1 uppercase"
                  style={{ textTransform: "uppercase", fontWeight: "bold" }}
                >
                  {recruitments.row.original.designation}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("DESCRIPTIF"),
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5
                  className="fs-14 mb-1 "
                  style={{
                    width: 200,
                    height: 50,
                    overflow: "clip",
                    verticalAlign: "middle",
                  }}
                >
                  <Link
                    to={`/#/${recruitments.row.original.id}/`}
                    className="text-muted"
                  ></Link>
                  {recruitments.row.original.description}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("MONTANT"),
        accessor: "montant",
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div className="">
                <h5 className="">
                  <Link
                    to={`/#/${recruitments.row.original.id}/`}
                    className="text-dark "
                  ></Link>
                  {recruitments.row.original.montant}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("NOMBRE DE MOIS"),
        accessor: "nbr_mois",
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div>
                <h5>
                  <Link
                    to={`/#/${recruitments.row.original.id}/`}
                    className="text-dark "
                  ></Link>
                  {recruitments.row.original.nbr_mois}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("TYPE"),
        accessor: "_type",
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div className="">
                <h5
                  className=" mb-1 badge badge-soft-primary"
                  style={{ textAlign: "center" }}
                >
                  <Link
                    to={`/#/${recruitments.row.original.id}/`}
                    className="text-dark "
                  ></Link>
                  {recruitments.row.original._type}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "ACTIONS",
        Cell: (cellProps) => {
          const recruitmentsData = cellProps.row.original;
          return (
            <div>
              <li className="list-inline-item" title={props.t("Modifier")}>
                <Link
                  to={`/subscription-types-update/${recruitmentsData.id}/`}
                  className="text-warning d-inline-block"
                >
                  <i className="ri-pencil-fill align-bottom"></i>
                </Link>
              </li>

              <li className="list-inline-item" title={props.t("Voir")}>
                <Link
                  to={`/subscription-types-details/${recruitmentsData.id}/`}
                  className="text-warning d-inline-block"
                >
                  <i className="ri-eye-fill"></i>
                </Link>
              </li>
            </div>
          );
        },
      },
    ],
    [props]
  );

  document.title = props.t("Liste des types d'abonnement");

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteProduct}
        onCloseClick={() => setDeleteModal(false)}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb
          title={props.t("Liste des types d'abonnement")}
          pageTitle={props.t("Liste des types d'abonnement")}
        />
        <Row>
          <div className="col-xl-12 col-lg-12">
            <div>
              <div className="card">
                <div className="card-body pt-0">
                  {isLoading ? (
                    <div className="py-4 text-center">
                      <div>
                        <lord-icon
                          src="https://cdn.lordicon.com/xjovhxra.json"
                          trigger="loop"
                          colors="primary:#0960b6,secondary:#02376b"
                          style={{ width: "72px", height: "72px" }}
                        ></lord-icon>
                      </div>
                      <div className="mt-4">
                        <h5>{props.t("Chargement")}...</h5>
                      </div>
                    </div>
                  ) : recrutements && recrutements.length > 0 ? (
                    <TableContainer
                      columns={columns}
                      data={recrutements || []}
                      isGlobalFilter={true}
                      isAddUserList={false}
                      customPageSize={10}
                      divClass="table-responsive mb-1"
                      tableClass="mb-0 align-middle table-borderless"
                      theadClass="table-light text-muted"
                      isTypeAbonnementFilter={true}
                    />
                  ) : (
                    <div className="py-4 text-center">
                      <div className="mt-4">
                        <h5>{props.t("Désolé, pas de resultats trouvés")}</h5>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};
SubscriptionTypesPage.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(SubscriptionTypesPage));
